<template>
  <div class="small-title"
       :class="{no_margin: no_margin}"
       v-html="text">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SmallTitle",
  props: {
    text: {
      type: String,
      default: ''
    },
    no_margin: {
      type: Boolean,
      default: false
    }
  }
}
</script>
